

<template>
	<div>
		<vFormItem :label="$t('fbb.warehouse.can_use_warehouse',{defaultValue:'可使用的仓库'})" label-width="150" v-if="type!=='query'">
			<vTransfer
				style="height:360px;"
				:data="getBillcusWareList"
				identifier="value"
				:target-keys="targetKeys"
				:list-style="listStyle"
				:render-format="renderFormat"
				filterable
                :filter-method="filterMethod"
				@on-transfer="handleChange"
			></vTransfer>
		</vFormItem>
		<TableList v-else v-bind="getTableProps"></TableList>
	</div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpCarrierServiceWareList } from '@/service/basicdata';
import { mapGetters } from 'vuex';
import mixin from "./mixin";
export default {
    mixins: [mixin],
    props: ['data'],
	components: {
		TableList
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			targetKeys: [],
			listStyle: {
				width: '30%',
				minWidth: '260px'
			},
		}
	},
	watch: {
		data(val) {
			this.targetKeys = val || [];
		}
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusWareList']),
		getTableProps() {
			return {
				ajaxRequest: HttpCarrierServiceWareList,
				startUp: 1,
				initFormData: {
					id: this.id,
				},
				columns: [{
					title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
					type: 'index',
					width: 100,
				}, {
					title: this.$t('fbb.warehouse.warehouse_name', { defaultValue: '仓库名称' }),
                    // key: 'warehouseId',
                    // render: (h, { row }) => this.findRenderLabel(this.getAllNowManageOrgList, row.key)
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row[0])

                },
                {
					title: this.$t('fbb.inbound.warehouse_type', { defaultValue: '仓库类型' }),
                    // key: 'warehouseId',
                    render: (h, { row }) => this.findRenderLabel(this.getWarehouseTypes, row[1])

                },
                ]
			}
		},
		// getTargetData() {
		// 	return this.targetKeys.map(key => {
		// 		const data = this.getSourceDataList.find(item => item.value == key);
		// 		return {
		// 			"channelId": data.value,
		// 			"channelCode": data.attach.flag,
		// 		}
		// 	})
		// }
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			this.targetKeys = targetKeys;
		},
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
	}
}
</script>
